const FilterOption = [
  {
    label: "Branch Manager",
    value: "branchManager",
  },
  {
    label: "Operator",
    value: "operator",
  },
  {
    label: "Accountant",
    value: "accountant",
  },
  {
    label: "User",
    value: "user",
  },
  {
    label: "PT Staff",
    value: "ptstaff",
  },
  {
    label: "SUB CODE",
    value: "SUBCODE",
  },
];

function getLabelForValue(value) {
  const option = FilterOption.find((option) => option.value === value);
  return option ? option.label : null;
}

const PolicyFilterTypes = [
  {
    label: "All Policy",
    value: "allPolicy",
    _id: "allPolicy",
  },
  {
    label: "Verify Pending",
    value: "verifyPending",
    _id: "verifyPending",
  },
  {
    label: "Approve Pending",
    value: "approvePending",
    _id: "approvePending",
  },
  {
    label: "Approved Policy",
    value: "approvedPolicy",
    _id: "approvedPolicy",
  },
  {
    label: "Rejected Policy",
    value: "rejectedPolicy",
    _id: "rejectedPolicy",
  },
];

// Shown after PolicyFilterTypes only to the admin-type logins (a policy that was cancelled with "Cancel Policy").
// Kept out of PolicyFilterTypes itself: other pages read that list by position.
const CancelledPolicyFilterType = {
  label: "Cancelled Policy",
  value: "cancelled",
  _id: "cancelled",
};

const PAYMENT_DETAILS = [
  {
    label: "Wallet",
    value: "FromWallet",
  },
  // {
  //   label: "Online",
  //   value: "Online",
  // },
];

const MINIMUM_PREMIUM_AMOUNT = 177;
const PREMIUM_PERCENTAGE = 118;
const GST_PERCENTAGE = 18;

const POLICY_TYPE_DETAILS = [
  {
    label: "CPA/RSA",
    value: "CPA/RSA",
  },
  // {
  //   label: "CPA",
  //   value: "CPA",
  // },
  // {
  //   label: "RSA",
  //   value: "RSA",
  // },
];

const GENDER_DETAILS = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
  {
    label: "Other",
    value: "Other",
  },
];

const NOMINEE_RELATIONSHIP_DETAILS = [
  {
    label: "Father",
    value: "Father",
  },
  {
    label: "Mother",
    value: "Mother",
  },
  {
    label: "Son",
    value: "Son",
  },
  {
    label: "Spouse",
    value: "Spouse",
  },
  {
    label: "Daughter",
    value: "Daughter",
  },
  {
    label: "Brother",
    value: "Brother",
  },
  {
    label: "Sister",
    value: "Sister",
  },
  {
    label: "Friend",
    value: "Friend",
  },
];

const BRISK_NOMINEE_RELATIONSHIP_DETAILS = [
  {
    label: "Father",
    value: "Father",
  },
  {
    label: "Mother",
    value: "Mother",
  },
  {
    label: "Wife",
    value: "Wife",
  },
  {
    label: "Husband",
    value: "Husband",
  },
  {
    label: "Sister",
    value: "Sister",
  },
  {
    label: "Son",
    value: "Son",
  },
  {
    label: "Daughter",
    value: "Daughter",
  },
  {
    label: "Brother",
    value: "Brother",
  },
  {
    label: "Other",
    value: "Other",
  },
];

const PolicyPDFStatus = {
  NOT_FOUND: "Not found",
  UPLOADED: "Uploaded",
};

const AWS_DIRECTORY_NAME = {
  AWS_USER_PHOTO_DIRECTORY_NAME: "UserPhoto",
  AWS_ADDRESS_PROOF_DIRECTORY_NAME: "AddressProof",
  AWS_ID_PROOF_DIRECTORY_NAME: "IDProof",
  AWS__PAN_CARD_DIRECTORY_NAME: "PANCard",
  AWS_EDUCATIONAL_PROOF_DIRECTORY_NAME: "EducationalProof",
  AWS_BANK_BOOK_DIRECTORY_NAME: "BankBook",
  AWS_PHONEPAY_QR_DIRECTORY_NAME: "PhonepayQR",
  AWS_PAYTM_QR_DIRECTORY_NAME: "PaytmQR",
  AWS_GOOGLEPAY_QR_DIRECTORY_NAME: "GooglepayQR",
  AWS_POLICY_FILE_DIRECTORY_NAME: "Policy",
  AWS_OTHER_FILE_DIRECTORY_NAME: "Other",
};

const ID_CONFIG = {
  BOOKING_CODE: "65e1be912d1be8b91b6400b3",
  SUBBOOKING_CODE: "65e1bf4a2d1be8b91b6400dc",
};

const filterOption = (input, option) =>
  option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
const filterSort = (optionA, optionB) => {
  if (!optionA.children === "Others") {
    return optionA?.children
      ?.toLowerCase()
      .localeCompare(optionB.children.toLowerCase());
  }
};

const checkUserType = (userType) => {
  const isUser = userType === "user" ? true : false;
  const isClient = userType === "CLIENT" ? true : false;
  const isOperator = userType === "operator" ? true : false;
  const isBranchManager = userType === "branchManager" ? true : false;
  const isSubCode = userType === "SUBCODE" ? true : false;
  return { isUser, isClient, isOperator, isBranchManager, isSubCode };
};

/**
 * Insurers a portal login can be stored for, in the order they are offered.
 *
 * ONE list, because it is read in four places that must agree: Add User, Add
 * Client, the profile's Account & Policy Settings, and the Online Policy's own
 * company validation. They were four hardcoded copies of ["Reliance",
 * "National"], so adding an insurer meant finding every one of them — and the
 * length is also the cap on how many credential rows can be added, so a copy
 * left behind silently blocks the new insurer's row from ever being created.
 *
 * The value is what gets SAVED as providerCredentials[].companyName and is
 * matched against the Make & Model master's company, so it must stay spelled
 * exactly as it is there.
 */
const PROVIDER_COMPANIES = ["Reliance", "National", "KSHEMA"];

/**
 * Insurers the Client Company Wallet keeps a balance for.
 *
 * Deliberately NOT the same list as PROVIDER_COMPANIES above. That one drives
 * the portal-login pickers (Add User / Add Client / Online Policy) and its
 * length caps how many credential rows exist — adding "Brisk" there would
 * offer a Brisk portal login that does not exist. The wallet tracks money for
 * Brisk even though there is no Brisk portal credential.
 *
 * These strings ARE the keys the balances are stored and read under, so they
 * must match RayalBrokers-backend's WALLET_COMPANIES character for character,
 * "KSHEMA" included. A mismatch shows 0.00 forever instead of erroring.
 */
// "RoadZen" (2026-11-03): the RoadZen certificates are charged from it, like "Brisk"
const WALLET_INSURERS = ["Reliance", "National", "KSHEMA", "Brisk", "RoadZen"];

export {
  PROVIDER_COMPANIES,
  WALLET_INSURERS,
  FilterOption,
  getLabelForValue,
  AWS_DIRECTORY_NAME,
  PolicyFilterTypes,
  CancelledPolicyFilterType,
  filterOption,
  filterSort,
  checkUserType,
  ID_CONFIG,
  PolicyPDFStatus,
  PAYMENT_DETAILS,
  GENDER_DETAILS,
  NOMINEE_RELATIONSHIP_DETAILS,
  BRISK_NOMINEE_RELATIONSHIP_DETAILS,
  POLICY_TYPE_DETAILS,
  MINIMUM_PREMIUM_AMOUNT,
  PREMIUM_PERCENTAGE,
  GST_PERCENTAGE,
};
